export default {
  'app.pwa.offline': 'Sie sind jetzt offline',
  'app.pwa.serviceworker.updated': 'Neue Inhalte sind verfügbar',
  'app.pwa.serviceworker.updated.hint':
    'Bitte drücken Sie die "Aktualisieren"-Schaltfläche, um die aktuelle Seite neu zu laden',
  'app.pwa.serviceworker.updated.ok': 'Aktualisieren',
};